import { useMovieActivityContext } from "src/components/film/filmwebid/MovieActivityContext";
import RatingPanel from "src/components/filmwebid/RatingPanel";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import StarSvg from "src/components/svg/StarSvg";
import getFraction from "src/lib/filmwebid/getFraction";
import classNames from "classnames";
import { useState } from "react";
import styles from "./UserRatings.module.css";

//#region [Props]
type UserRatingsProps = {
  className?: string;
  edi?: string;
  streamingId?: number;
};
//#endregion

//#region [Component]
export default function UserRatings({ className, edi, streamingId }: UserRatingsProps) {
  const movieActivityContext = useMovieActivityContext();

  const [showRatingPanel, setShowRatingPanel] = useState(false);

  const isLoading = movieActivityContext.isLoading;

  const onRatingPanelClose = (doUpdate: boolean) => {
    setShowRatingPanel(false);
    if (doUpdate) {
      movieActivityContext.activityUpdater();
    }
  };

  return (
    <div className={classNames(styles.SRatingsDisplay, className)}>
      {isLoading && <LoadingIndicator />}
      <h4 className={styles.SHeading}>
        {(isLoading || !movieActivityContext.activity?.movieUserInteraction?.rating)
          ? "Gi din vurdering:"
          : "Gjennomsnitt av vurderinger:"}
      </h4>
      <div className={styles.SStarContainer}>
        <StarSvg
          className={styles.SAverageMarkerStar}
          fractionSelected={movieActivityContext.isLoading ? 0 : getFraction(movieActivityContext.activity?.movieStats?.ratingAverage, 1)}
        />
        <StarSvg
          className={styles.SAverageMarkerStar}
          fractionSelected={movieActivityContext.isLoading ? 0 : getFraction(movieActivityContext.activity?.movieStats?.ratingAverage, 2)}
        />
        <StarSvg
          className={styles.SAverageMarkerStar}
          fractionSelected={movieActivityContext.isLoading ? 0 : getFraction(movieActivityContext.activity?.movieStats?.ratingAverage, 3)}
        />
        <StarSvg
          className={styles.SAverageMarkerStar}
          fractionSelected={movieActivityContext.isLoading ? 0 : getFraction(movieActivityContext.activity?.movieStats?.ratingAverage, 4)}
        />
        <StarSvg
          className={styles.SAverageMarkerStar}
          fractionSelected={movieActivityContext.isLoading ? 0 : getFraction(movieActivityContext.activity?.movieStats?.ratingAverage, 5)}
        />
      </div>
      {!isLoading && (
        <>
          {(movieActivityContext.activity?.movieStats?.ratingCount ?? 0) > 0 && (
            <div className={styles.SNumRated}>
              Så langt har {movieActivityContext.activity?.movieStats?.ratingCount} gitt vurdering
            </div>
          )}
          {(movieActivityContext.activity?.movieUserInteraction?.rating ?? 0) > 0 && (
            <>
              <h4 className={classNames(styles.SHeading, styles.SYourRatingHeading)}>Din vurdering:</h4>
              <div className={styles.SStarContainer}>
                <StarSvg className={styles.SUserRatingMarkerStar} selected={movieActivityContext.activity?.movieUserInteraction?.rating! >= 1} />
                <StarSvg className={styles.SUserRatingMarkerStar} selected={movieActivityContext.activity?.movieUserInteraction?.rating! >= 2} />
                <StarSvg className={styles.SUserRatingMarkerStar} selected={movieActivityContext.activity?.movieUserInteraction?.rating! >= 3} />
                <StarSvg className={styles.SUserRatingMarkerStar} selected={movieActivityContext.activity?.movieUserInteraction?.rating! >= 4} />
                <StarSvg className={styles.SUserRatingMarkerStar} selected={movieActivityContext.activity?.movieUserInteraction?.rating! === 5} />
              </div>
            </>
          )}
        </>
      )}

      {showRatingPanel && (
        <RatingPanel
          edi={edi}
          streamingId={streamingId}
          onClose={onRatingPanelClose}
          movieStats={movieActivityContext.activity?.movieStats}
          hasUserReview={!!movieActivityContext.activity?.movieUserInteraction?.review}
          userRating={movieActivityContext.activity?.movieUserInteraction?.rating}
        />
      )}
    </div>
  );
}
//#endregion
